import React from 'react';

import styles from './thumbnail-loading-indicator.module.scss';

export const ThumbnailLoadingIndicator = () => {
    return (
        <div className={styles.container}>
            <div className="flex animate-pulse flex-row items-center h-full justify-center p-4 flex justify-between flex-col">
                <div className='h-full bg-gray-300 my-4 w-full'/>

                <div className="flex flex-col space-y-3">
                    <div className="w-36 bg-gray-300 h-2 rounded-md ">
                    </div>
                    <div className="w-24 bg-gray-300 h-2 rounded-md ">
                    </div>
                </div>
            </div>
        </div>
    );
};
